import ApiHelper from "../../helpers/ApiHelper";
import BaseService from "../BaseService";

class FaqService extends BaseService {

    static url = "jobs";
    static apis = {
        applyToJob: { path: this.url+'/applyToJob', method: "post" },
        allJobs: { path: this.url+'/all', method: "get" },
        allBlogs: { path: 'blog', method: "get" },
        getBlog: { path: 'blog', method: "get" },
    }

    constructor(repo) {
        super(repo);
        this.repo = new ApiHelper("boutique");
    }

    getBoutiqueData(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: FaqService.apis.getBoutiqueData.path+'/'+id,
                    method: FaqService.apis.getBoutiqueData.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    allJobs() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: FaqService.apis.allJobs.path,
                    method: FaqService.apis.allJobs.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    allBlogs() {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: FaqService.apis.allBlogs.path,
                    method: FaqService.apis.allBlogs.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getBlog(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: FaqService.apis.getBlog.path+'/'+id,
                    method: FaqService.apis.getBlog.method,
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    getBoutiqueEquipment(id) {
        var that = this;
        return new Promise((resolve, reject) => {
            that.axios({
                    url: '/kits/filter?brands=['+id+']',
                    method: 'get',
                })
                .then(resp => {
                    resolve(resp);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    applyToJob(data) {
        var that = this;
        return new Promise((resolve, reject) => {
            that
                .axios({
                    url: FaqService.url + "/" + data.id + '/apply',
                    method: FaqService.apis.applyToJob.method,
                    data: data,
                    showLoader: true,
                    authorization: false,
                })
                .then((response) => {
                    resolve(response);
                })
                .catch((error) => {
                    reject(error.response);
                });
        });
    }

}

export default FaqService;